<template>
    <div class="DispatchHostingRequest container-fluid">

        <!--CREATE NEW TRANSACTION-->
        <b-modal ref="modal-component" size="lg" title="Dispatch Hosting Request" hide-footer>
            <b-container>
                <b-form @submit="SaveRecord">
                    <b-row>
                        <b-col>
                            <h4>Message Info</h4>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <div class="form-group">
                                <label>Text Message ({{SMSCharactersRemaining}} characters remaining):</label>
                                <textarea required rows="6" v-model="TargetRecord.SMSMessageBody" class="form-control" maxlength="300"></textarea>
                            </div>
                        </b-col>
                        <b-col>
                            <div class="form-group">
                                <label>Send copy of Text message to the following (enter 10 digit phone numbers, separated by commas):</label>
                                <textarea rows="4" v-model="TargetRecord.AdditionalSMSRecipients" class="form-control"></textarea>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <div class="form-group">
                                <label>Email Message:</label>
                                <textarea required rows="6" v-model="TargetRecord.EmailMessageBody" class="form-control"></textarea>
                            </div>
                        </b-col>
                        <b-col>
                            <div class="form-group">
                                <label>Send copy of the Email to the following recipients:</label>
                                <textarea rows="4" v-model="TargetRecord.AdditionalEmailRecipients" class="form-control"></textarea>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <div class="form-group">
                                <label>Distance Check</label>
                                <input type="text" v-model="TestAddress" class="form-control" placeholder="Enter full address to check distance from families" />
                            </div>

                            <b-button @click="DistanceCheck()">Check Distance from Families</b-button>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <h4>Selected Families</h4>
                            <p>The families below come from the Volunteer Families list with all filters applied.  To change this list of available families, adjust the filtering and come back to this window.</p>
                            <b-button @click="SelectAllFamilies()">Select All</b-button>  <b-button @click="DeselectAllFamilies()">Deselect All</b-button> <span v-if="ShowMiles" style="float: right;"><b-button @click="SelectAllFamiliesInRange()">Select In Range (Miles)</b-button> <input type="number" placeholder="Miles" step="1" class="form-control" v-model="MilesToFilter" /></span>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <table class="table-utility">
                                <thead>
                                    <tr>
                                        <th><font-awesome-icon :icon="['fa', 'mobile-retro']" /></th>
                                        <th><font-awesome-icon :icon="['fa', 'envelope']" /></th>
                                        <th>Family</th>
                                        <th>Location</th>
                                        <th>Phone</th>
                                        <th>Email</th>
                                    </tr>
                                </thead>
                                <tbody v-for="family in FamiliesAvailable">
                                    <tr>
                                        <td colspan="3" class="bold">{{family.Name}}</td>
                                        <td class="bold">{{family.Location}} {{family.DistanceFromAddressCheckLabel}}</td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr v-for="contact in family.Contacts">
                                        <td>
                                            <b-form-checkbox :value="true" v-model="contact.SMSCheckedStatus" size="lg"></b-form-checkbox>
                                        </td>
                                        <td>
                                            <b-form-checkbox :value="true" v-model="contact.EmailCheckedStatus" size="lg"></b-form-checkbox>
                                        </td>
                                        <td colspan="2">{{contact.Name}} <span v-if="!contact.IsTextMessageOK" class="red">Text Preference Off </span><span v-if="!contact.IsEmailMessageOK" class="red">Email Preference Off</span></td>
                                        <td><span v-if="contact.PhoneNumber" :class="{ red: contact.PhoneNumber && contact.PhoneNumber.PhoneNumberDigits && contact.PhoneNumber.PhoneNumberDigits.length != 10 }">{{contact.PhoneNumber.FormattedPhoneNumber}}</span></td>
                                        <td>{{contact.Email}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <p>Pressing <span class="bold">DISPATCH MESSAGES</span> will send a text messages and emails to the recipients selected above.  If this window closes and you do not get an error message, then the messages have been sent.</p>
                        </b-col>
                    </b-row>
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">
                            <b-button size="md" variant="secondary" @click="HideModal()">
                                CANCEL
                            </b-button>
                            <b-button size="md" variant="success" type="submit">
                                DISPATCH MESSAGES
                            </b-button>
                        </div>
                    </b-row>
                </b-form>
            </b-container>
        </b-modal>
    </div>
</template>

<script>
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';

    import vSelect from 'vue-select'
    import 'vue-select/dist/vue-select.css';

    import SelectFromEndpoint from '../../../Core/CustomInputElements/SelectFromEndpoint.vue';

    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faPlus } from '@fortawesome/free-solid-svg-icons';
    library.add(faPlus);
    import { faMobileRetro } from '@fortawesome/free-solid-svg-icons';
    library.add(faMobileRetro);
    import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
    library.add(faEnvelope);

    
    export default {
        name: "DispatchHostingRequest",
        created() {
 
        },
        props: [],
        data: function () {
            return {
                TargetRecord: {},
                FamiliesAvailable: [],
                FamilyFilters: {},
                TestAddress: "",
                MilesToFilter: null,
                ShowMiles: false,
                //AUX
                DateConfig: {
                    dateFormat: 'Y-m-d',
                    allowInput: true,
                    altInput: true,
                    altFormat: 'm/d/Y',
                    required: false,
                },
                TargetRecord: {}
            };
        },
        methods: {
            //API
            SaveRecord(e) {
                e.preventDefault();
                let smsFamiliesSelected = [];
                let emailFamiliesSelected = [];
                this.FamiliesAvailable.forEach(function (fam) {
                    fam.Contacts.forEach(function (contact) {
                        if (contact.SMSCheckedStatus == true) {
                            smsFamiliesSelected.push(contact.Id);
                        }
                        if (contact.EmailCheckedStatus == true) {
                            emailFamiliesSelected.push(contact.Id);
                        }
                    });
                });
                this.TargetRecord.SMSFamiliesSelected = smsFamiliesSelected;
                this.TargetRecord.EmailFamiliesSelected = emailFamiliesSelected;
                this.$MasterAPI.ExecuteRequest("POST", "StrongFamilies/Communication/MassMessages", this.TargetRecord, this.SaveRecordSuccess, () => { }, true);
            },
            SaveRecordSuccess(response) {
                //this.$emit("updatetable");
                this.HideModal();
            },
            //UI
            ShowModal(familiesAvailable, filters) {
                this.TestAddress = "",
                this.MilesToFilter = null,
                this.ShowMiles = false,
                this.FamilyFilters = JSON.parse(JSON.stringify(filters));
                this.TargetRecord = {
                    SMSMessageBody: "",
                    AdditionalSMSRecipients: "",
                    EmailMessageBody: "",
                    AdditionalEmailRecipients: ""
                };
                this.FamiliesAvailable = JSON.parse(JSON.stringify(familiesAvailable));
                this.FamiliesAvailable.forEach(function (fam) {
                    fam.Contacts.forEach(function (contact) {
                        contact.SMSCheckedStatus = false;
                        contact.EmailCheckedStatus = false;
                    });

                });
                //this.FamiliesAvailable = [];
                this.$refs['modal-component'].show();
            },
            HideModal() {
                this.$refs['modal-component'].hide();
            },
            SelectAllFamilies() {
                this.FamiliesAvailable.forEach(function (fam) {
                    fam.Contacts.forEach(function (contact) {
                        if (contact.PhoneNumber && contact.PhoneNumber.PhoneNumberDigits && contact.PhoneNumber.PhoneNumberDigits.length == 10 && contact.IsTextMessageOK) {
                            contact.SMSCheckedStatus = true;
                        } else {
                            contact.SMSCheckedStatus = false;
                        }

                        if (contact.Email != null && contact.Email.length > 0 && contact.IsEmailMessageOK) {
                            contact.EmailCheckedStatus = true;
                        } else {
                            contact.EmailCheckedStatus = false;
                        }
                    });
                    
                });
                this.$forceUpdate();
            },
            SelectAllFamiliesInRange() {
                let vm = this;
                this.FamiliesAvailable.forEach(function (fam) {
                    fam.Contacts.forEach(function (contact) {
                        if (contact.PhoneNumber && contact.PhoneNumber.PhoneNumberDigits && contact.PhoneNumber.PhoneNumberDigits.length == 10 && fam.DistanceFromAddressCheck <= vm.MilesToFilter && contact.IsTextMessageOK) {
                            contact.SMSCheckedStatus = true;
                        } else {
                            contact.SMSCheckedStatus = false;
                        }

                        if (contact.Email != null && contact.Email.length > 0 && fam.DistanceFromAddressCheck <= vm.MilesToFilter && contact.IsEmailMessageOK) {
                            contact.EmailCheckedStatus = true;
                        } else {
                            contact.EmailCheckedStatus = false;
                        }
                    });
                });
                this.$forceUpdate();
            },
            DeselectAllFamilies() {
                this.FamiliesAvailable.forEach(function (fam) {
                    fam.Contacts.forEach(function (contact) {
                        contact.SMSCheckedStatus = false;
                        contact.EmailCheckedStatus = false;
                    })
                    
                });
                this.$forceUpdate();
            },
            DistanceCheck() {
                let filters = {};
                this.FamilyFilters.forEach(function (item) {
                    filters[item.Name] = item.Value;
                });
                filters.AddressForDistanceCheck = this.TestAddress;
                filters.MilesToFilter = this.MilesToFilter;
                this.$MasterAPI.ExecuteRequest("GET", "StrongFamilies/VolunteerFamilies", filters, this.DistanceCheckSuccess, () => { }, true);
            },
            DistanceCheckSuccess(response) {
                this.ShowMiles = true;
                this.FamiliesAvailable = response.data.data;
            },
            //AUX
            formatDate(value, fmt = 'MM/DD/YY') {
                return (value == null)
                    ? ''
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            }
        },
        components: {
            flatPickr,
            vSelect,
            SelectFromEndpoint
        },
        computed: {
            SMSCharactersRemaining: function () {
                if (this.TargetRecord.SMSMessageBody) {
                    let initialCount = 300 - this.TargetRecord.SMSMessageBody.length;
                    if (initialCount < 0) {
                        return 0;
                    } else {
                        return initialCount;
                    }
                } else {
                    return 300;
                }
                
            }
        },
        mounted() {
            
        }
    }
</script>

<style scoped>
</style>